import { TCompany } from 'types'
import { IFinancial } from './financial'
import { IGrossWageRules } from './grossWageRules'
import { IHomologation } from './homologation'
import IPayment from './payment'
import { IContact } from './contact'
import { IUserFunction } from './auth'

export enum CreditLimitType {
  'regra-salario-bruto' = 'Regra salário bruto',
  'regra-faixa-idade-e-sexo' = 'Regra faixa idade e sexo',
}

export interface ICovenant {
  status: string
  financeira: IFinancial
  limite_financiado: number
  margem_emprestimo: number
  margem_rescisao: number
  idade_minima: number
  idade_maxima: number
  dias_cobranca_multa: number
  regras_salario_bruto: IGrossWageRules[]
  taxas_grupo: string
  taxa_grupo_renegociacao: string
  empresa: TCompany
  homologacao: IHomologation
  promotora: string
  pagamento: IPayment
  id: string
  tipo_de_recebimento: string
  contato: IContact
  localizador: string
  exige_agente_certificado: boolean
  user_funcao: IUserFunction
  validacao_documentos: string
  tipo_limite_credito: keyof typeof CreditLimitType
  tipo_limite_credito_cartao: keyof typeof CreditLimitType
}
